// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M6 1.5V4H2V9H22V4H18V1.5H16V4H8V1.5H6Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M22 22V10.9995H2V22H22Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-calendar-filled')
export default class CalendarFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'calendar-filled',
    }
  }
}
